import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as settings from "../lib/air-api-constant";

@Injectable({
  providedIn: 'root'
})
export class DirectLinkService {

  constructor(protected http: HttpClient) { 

  }

  // getShipmentList(request: String) {
  //   return this.http.get(settings.AirAppRoutes.DirectLink.DIRECT_LINK_API + '/' + request);
  // }
}
